import { IndustryEditPage } from "@/features/learning-content/pages/IndustryEdit";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

const IndustryEdit: FC = () => {
  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <IndustryEditPage />
      </Box>
    </Stack>
  );
};

export default IndustryEdit;
